import { createRouter, createWebHashHistory } from 'vue-router'

// 导入页面组件
import Home from '@/views/Home.vue'
import Business from '@/views/Business.vue'
import Clients from '@/views/Clients.vue'
import About from '@/views/About.vue'
import Contact from '@/views/Contact.vue'

// 配置路由
const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: '俊采猎头 - 您身边的猎头顾问',
      description: '俊采猎头（上海俊采企业管理咨询有限公司）成立于2006年，专业提供物流供应链、互联网电子商务、新能源电力等行业的中高端人才寻访与招聘服务。'
    }
  },
  {
    path: '/business',
    name: 'Business',
    component: Business,
    meta: {
      title: '服务项目 - 俊采猎头',
      description: '俊采猎头服务涵盖了解需求、人才寻访、面试评估、人才推荐、跟踪服务全流程，专注物流供应链、互联网、新能源电力等行业的专业猎头服务。'
    }
  },
  {
    path: '/clients',
    name: 'Clients',
    component: Clients,
    meta: {
      title: '成功案例 - 俊采猎头',
      description: '俊采猎头已为众多物流、供应链、电力、互联网等行业的知名企业提供专业的中高端人才寻访服务，赢得客户的持续信赖。'
    }
  },
  {
    path: '/about',
    name: 'About',
    component: About,
    meta: {
      title: '关于我们 - 俊采猎头',
      description: '俊采猎头成立于2006年，总部位于上海，在广州、合肥、成都设有分公司，是一家专业的猎头与人力资源服务机构。'
    }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact,
    meta: {
      title: '联系我们 - 俊采猎头',
      description: '联系俊采猎头：地址位于上海市普陀区中山北路华源世界大厦，咨询热线 021-63806309，为您提供专业的猎头与招聘服务。'
    }
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    
    if (to.hash) {
      return { 
        el: to.hash,
        behavior: 'smooth',
        top: 80 // 头部导航栏的高度
      }
    }
    
    return { top: 0 };
  }
})

// 全局前置守卫，设置页面标题与 meta 描述（利于 SEO / AI 引擎抓取）
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }

  // 同步更新 <meta name="description">，无则创建
  if (to.meta.description) {
    let descTag = document.querySelector('meta[name="description"]');
    if (!descTag) {
      descTag = document.createElement('meta');
      descTag.setAttribute('name', 'description');
      document.head.appendChild(descTag);
    }
    descTag.setAttribute('content', to.meta.description);
  }

  next();
});

export default router 